import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { Button, Typography } from "@mui/material";

function FinishStep({ data, handleReset }) {
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ textAlign: "center" }}>
        <Icon
          icon="icon-park-twotone:success"
          color="lawngreen"
          width={"20vh"}
          height={"20vh"}
          style={{ margin: 25 }}
        />
        <Typography variant="h4" id="success-dialog-description">
          Mitglied{" "}
          <b>{data.memberData.firstName + " " + data.memberData.lastName}</b>{" "}
          wurde erfolgreich erstellt
        </Typography>
      </div>
      <Button
        onClick={handleReset}
        variant="contained"
        color="info"
        sx={{
          mt: 5,
          mb: 5,
          fontSize: "125%",
        }}
      >
        Weiteres Mitglied hinzufügen
      </Button>
    </div>
  );
}

FinishStep.propTypes = { data: PropTypes.object, handleReset: PropTypes.func };

export default FinishStep;
